import Game from '../../../Game';
import { ContextType } from '../../../State/Game/IContext';
import BaseMenu from './BaseMenu';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import BaseUISystem from '../BaseUISystem';
import { UIActions } from '../../../State/UI/UIActions';
import { GameActions } from '../../../State/Game/GameActions';
import {
    AdvertisementArea,
    AdvertisementType,
    RewardType,
} from '../../../Utility/SDK/Advertisement';
import Renderable from '../../../Component/Renderable';
import ElementComponent from '../../../Component/UI/Element';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import { applyDefaultButtonAnimation } from '../UIHelper';

const BTN_CLOSE: string = 'main_container/close_button';
const BTN_WATCH_AD: string = 'main_container/watch_ad_button';
const BTN_SHOP: string = 'main_container/shop_button';
const TEXT_GET_COINS = 'main_container/get_coins_text';

export default class NoCoinsMenuHandler extends BaseMenu {
    constructor(uiSystem: BaseUISystem) {
        super('noCoinsMenu', uiSystem);
    }

    protected onShow(params?: any): void {
        const btnWatchAd = this.element.find(BTN_WATCH_AD);
        const btnWatchAdElement = btnWatchAd.getComponent(ElementComponent);

        const btnShop = this.element.find(BTN_SHOP);
        const btnShopElement = btnShop.getComponent(ElementComponent);

        const textGetCoins = this.element.find(TEXT_GET_COINS);

        // Show Ads button, IAP button, or both (only if supported).
        const platform = Game.state.getState().platform;
        if (platform.adsRewarded && platform.IAPSupport) {
            btnWatchAd.getComponent(Renderable).visible = true;
            textGetCoins.getComponent(Renderable).visible = true;
            btnWatchAdElement.anchorTopLeft.x = 0.3;
            btnWatchAdElement.anchorBottomRight.x = 0.3;

            btnShop.getComponent(Renderable).visible = true;
            btnShopElement.anchorTopLeft.x = 0.7;
            btnShopElement.anchorBottomRight.x = 0.7;
        } else if (platform.adsRewarded && !platform.IAPSupport) {
            btnWatchAd.getComponent(Renderable).visible = true;
            textGetCoins.getComponent(Renderable).visible = true;
            btnWatchAdElement.anchorTopLeft.x = 0.5;
            btnWatchAdElement.anchorBottomRight.x = 0.5;

            btnShop.getComponent(Renderable).visible = false;
        } else if (!platform.adsRewarded && platform.IAPSupport) {
            btnWatchAd.getComponent(Renderable).visible = false;
            textGetCoins.getComponent(Renderable).visible = false;

            btnShop.getComponent(Renderable).visible = true;
            btnShopElement.anchorTopLeft.x = 0.5;
            btnShopElement.anchorBottomRight.x = 0.5;
        }
    }

    protected onCreate(): void {
        // Button close.
        const btnClose = this.element.find(BTN_CLOSE);
        btnClose.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.hidePopup(this.name));
        });
        applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);

        const btnShop = this.element.find(BTN_SHOP);
        btnShop.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.showPopup('shopMenu', {}));
        });
        applyDefaultButtonAnimation(btnShop, AUDIO_UI_BUTTON_DEFAULT);

        const btnWatchAd = this.element.find(BTN_WATCH_AD);
        btnWatchAd.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(
                GameActions.setContext(ContextType.DISPLAY_ADVERTISEMENT, {
                    placement: {
                        id: 0 /*changed from Game.config.adRewardedID*/,
                        type: AdvertisementType.REWARDED,
                    },
                    payload: {
                        g_gameArea: AdvertisementArea.NO_COINS_MENU,
                        g_rewardType: RewardType.COINS_100,
                    },
                })
            );
        });
        applyDefaultButtonAnimation(btnWatchAd, AUDIO_UI_BUTTON_DEFAULT);
    }
}
